import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const DEFAULT_SIZE = '16px';
const DEFAULT_COLOR = 'rgba(0, 0, 0, 0.6)';

interface SpinnerProps {
  size?: string;
  color?: string;
}

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const AnimatedSpinner = styled.span<SpinnerProps>`
  width: ${({ size = DEFAULT_SIZE }) => size};
  height: ${({ size = DEFAULT_SIZE }) => size};
  border: 1px solid ${({ color = DEFAULT_COLOR }) => color};
  border-top-color: transparent !important;
  border-radius: 50%;
  display: inline-block;
  transform: rotate(0deg);
  animation: ${spin} 0.4s linear infinite;
`;

export const Spinner = ({ size, color, ...props }: SpinnerProps): JSX.Element => {
  return <AnimatedSpinner size={size} color={color} {...props} />;
};
